<template>
  <div class="select-course-assistant-question-list">
    <card title="您孩子最急需解决的问题是？">
      <div class="select-course-assistant-question-list-item"
           v-for="(item, index) in list"
           :key="index"
           @click="handleClickItem(item.answer, item.path, item.id)"
      >
        {{ item.question }}
      </div>
    </card>
  </div>
</template>

<script>
  import Card from '@/pages/SelectCourseAssistant/components/Card';

  export default {
    name: 'SelectCourseAssistantQuestionListPage',
    components: {
      Card,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    methods: {
      handleClickItem(answer, path, id) {
        this.$router.push({
          name: 'SelectCourseAssistantRecommend',
          query: {
            answer,
            path,
            id,
          },
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .select-course-assistant-question-list {
    height: 100%;
    &-item {
      box-sizing: border-box;
      width: 590px;
      height: 112px;
      padding: 0 25px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: @color-text-base;
      font-size: 30px;
      background: @background-color-lighter;
      border-radius: 20px;

      &:not(:last-child) {
        margin-bottom: @size-base;
      }
    }
  }

</style>
